module.exports = __webpack_public_path__ + "img/payment02.5ddffbc5.png";